import { useState } from "react";
import { X, Plus } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Reveal, MaskLines } from "./Motion";
import { GALLERY } from "@/lib/gallery";

const CATS = ["Tous", "Après travaux", "Avant / pendant"];

export const Gallery = () => {
  const [cat, setCat] = useState("Tous");
  const [open, setOpen] = useState(null);
  const list = GALLERY.filter((p) => cat === "Tous" || p.cat === cat);
  return (
    <section id="galerie" data-testid="gallery-section" className="bg-paper px-5 py-24 sm:px-8 lg:py-32">
      <div className="mx-auto max-w-[1400px]">
        <div className="mb-12 flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <p className="eyebrow text-gold-deep mb-6">Galerie photos</p>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.02]">
              <MaskLines lines={["Nos chantiers,", <em key="e" className="text-clay">en images.</em>]} />
            </h2>
          </div>
          <div className="flex flex-wrap gap-2" data-testid="gallery-filters">
            {CATS.map((c) => (
              <button key={c} onClick={() => setCat(c)} data-testid={`gallery-filter-${CATS.indexOf(c)}`}
                className={`border px-4 py-2 text-sm transition-colors duration-300 ${cat === c ? "border-ink bg-ink text-paper" : "border-ink/20 hover:border-ink"}`}>
                {c}
              </button>
            ))}
          </div>
        </div>
        <div className="columns-1 gap-4 sm:columns-2 lg:columns-3">
          {list.map((p, i) => (
            <Reveal key={p.src + cat} delay={(i % 3) * 0.06} className="mb-4 break-inside-avoid">
              <button onClick={() => setOpen(p)} data-testid={`gallery-item-${i}`} className={`group relative block w-full overflow-hidden bg-paper-deep text-left ${p.tall ? "aspect-[1/2]" : p.wide ? "aspect-[5/2]" : "aspect-[3/2]"}`}>
                <img src={p.src} alt={p.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-105" />
                <span className="absolute inset-0 bg-gradient-to-t from-ink/80 via-transparent to-transparent opacity-80 transition-opacity duration-500 group-hover:opacity-100" />
                <span className="absolute bottom-0 left-0 right-0 flex items-end justify-between gap-4 p-5 text-paper">
                  <span>
                    <span className="eyebrow text-gold">{p.cat}</span>
                    <span className="mt-1 block font-display text-2xl leading-tight">{p.title}</span>
                  </span>
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-paper text-ink transition-transform duration-500 group-hover:rotate-90"><Plus className="h-4 w-4" /></span>
                </span>
              </button>
            </Reveal>
          ))}
        </div>
      </div>
      <Dialog open={!!open} onOpenChange={(v) => !v && setOpen(null)}>
        <DialogContent aria-describedby={undefined} className="max-w-5xl border-0 bg-ink p-0 text-paper [&>button]:hidden" data-testid="gallery-lightbox">
          <DialogTitle className="sr-only">{open?.title}</DialogTitle>
          {open && (
            <figure>
              <img src={open.src} alt={open.title} className="max-h-[80vh] w-full object-contain" />
              <figcaption className="flex items-center justify-between p-5">
                <span><span className="eyebrow text-gold">{open.cat}</span><span className="block font-display text-2xl">{open.title}</span></span>
                <button onClick={() => setOpen(null)} data-testid="gallery-lightbox-close" aria-label="Fermer" className="p-2"><X className="h-5 w-5" /></button>
              </figcaption>
            </figure>
          )}
        </DialogContent>
      </Dialog>
    </section>
  );
};
